<div *ngIf="catalogErrorMessage == null">
    <span id="stylesheet"></span>
    <ngx-spinner type="ball-clip-rotate" bdColor="rgba(255,255,255,0.54)" color="#2fb36d" size="large"></ngx-spinner>
    <ccl-drawer focusTrap> <router-outlet name="drawer"></router-outlet> </ccl-drawer>
    <ccl-popup> <router-outlet name="popup"></router-outlet> </ccl-popup>
    <router-outlet *ngIf="loaded"></router-outlet>
</div>
<div *ngIf="catalogErrorMessage != null">
    <div [innerHTML]="catalogErrorMessage | safeHtml"></div>
</div>